var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-button',{staticClass:"dropdown-actions__btn dropdown-actions__btn--dispute",attrs:{"disabled":_vm.disabled,"type":_vm.type,"data-cy":_vm.commonCy.SINGLE_ORDER.BUTTON__DISPUTE},on:{"click":function($event){return _vm.$emit('actionClicked')}}},[_vm._v(" Dispute ")])
}
var staticRenderFns = []

export { render, staticRenderFns }